// extracted by mini-css-extract-plugin
export default {"uploaded-gallery-image":"UploadedImage_uploaded-gallery-image__7nuGO","floating-remove-button":"UploadedImage_floating-remove-button__H8EcD"};